__webpack_require__.p = "https://rescdn-sea.battleteams2.com/www-res/ssjj2res/ssjj2-page-view-fe/dist/";